/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */

if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};

GS.Filters.ShadowFilter=new Class({
    Extends: GS.Filters.BaseFilter,
    class_name:'GS.Filters.ShadowFilter',
    options:{
        'debug':0,
        'dx': 0,
        'dy':0,
        'color': '#000',
        'blur':10,
        'inType':'SourceAlpha'
    },
    filter: {
        'id':0,
        'container':null,
        'blur':null,
        'offset':null,
        'color':null
    }
    /*initialize:function(conf){
        this.parent(conf);
    }*/
});


/**
 * Update the element Drop Shadow Filter
 * @param {type} obj
 * @returns {void}
 */
GS.Filters.ShadowFilter.prototype.update=function(obj){
    //console.warn('UPDATING THE SHADOW (ONLY) EFFECT `#%s`!', this.filter.id, obj);
    this.filter.offset.setAttribute('dx',obj.dx);
    this.filter.offset.setAttribute('dy',obj.dy);
    this.filter.blur.setAttribute('stdDeviation',obj.blur);
    var cMatrix;
    if(!obj.display){
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(obj.color);
        //alert('hide shadow....');
    }else{
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(obj.color);
    }
    
    this.filter.color.setAttribute("values",cMatrix);
};


GS.Filters.ShadowFilter.prototype.createFilter=function(){
    var fID,feGaussianBlur,feOffset,cMatrix,feColorMatrix,
    feMerge,feMergeShadow,feMergeSurce;
    
    //Add defs group
    var f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','x':'-150%','y':'-150%','width':'400%','height':'400%'/*,'enable-background':'accumulate'*/});
    this.filter.container=f;
    //console.warn('CREATING THE SHADOW (ONLY) EFFECT `#%s`!', this.filter.id);
    
    
    //Add Gaussian Blur Filter
    feGaussianBlur = new Element('feGaussianBlur',{'in':'SourceAlpha','result':'blur','stdDeviation':this.options.blur});
    this.filter.blur=feGaussianBlur;
    
    //Add Offset Filter
    feOffset = new Element('feOffset',{'in':'blur','result':'shadow','dx':this.options.dx,'dy':this.options.dy});
    this.filter.offset=feOffset;
    
    //Add Color Matrix Filter
    if(!this.options.shadow.display){
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.color);
    }else{
        cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.color);
    }
    feColorMatrix = new Element('feColorMatrix',{'in':'shadow','result':'cloredShadow','type':'matrix','values':cMatrix});
    this.filter.color=feColorMatrix;
    
    //Merging Filters
    feMerge = new Element('feMerge');
    feMergeShadow = new Element('feMergeNode',{'in':'cloredShadow','mode':'normal'});
    feMergeSurce = new Element('feMergeNode',{'in':'SourceGraphic','mode':'normal'});
    feMerge.adopt([feMergeShadow,feMergeSurce]);
    this.filter.container.adopt([feGaussianBlur,feOffset,feColorMatrix,feMerge]);

    //this.filter.container.adopt([feGaussianBlur,feOffset,feColorMatrix]);
    this.defs.adopt(f);

};

/**
 * Apply/Attach filter to element
 * @param {SVG Element} ele
 * @returns {void}
 */
/*GS.Filters.ShadowFilter.prototype.applyTo=function(ele){
    
    //ele.node.style['filter']="url('#"+this.filter.id+"')";
    
    $(ele.node).setStyle('box-shadow',this.options.dx+' '+this.options.dy+''+this.options.blur+' rgba(0,0,0,1)');
    
    //ele.node.setAttribute('filter',"url('#"+this.filter.id+"')");
    //ele.node.style['-webkit-filter']="url('#"+this.filter.id+"')";
    
    
};*/
